import React, {Component} from 'react';


class Insert extends Component {

    constructor(props) {
        super(props);
        this.state = {
            partiJsonText: "",
            eventsJsonText: ""
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }


    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });

    }

    onSubmit(e) {
        e.preventDefault();
        /*console.log('dkk-proeve-parti-' + process.env.REACT_APP_ENV, this.state.partiJsonText);
        console.log(this.state.partiJsonText);
        console.log('dkk-proeve-lydighet-parti-events-' + process.env.REACT_APP_ENV, this.state.eventsJsonText);
        console.log(this.state.eventsJsonText);
*/
        window.localStorage.setItem('dkk-proeve-parti-' + process.env.REACT_APP_ENV, this.state.partiJsonText);
        window.localStorage.setItem('dkk-proeve-lydighet-parti-events-' + process.env.REACT_APP_ENV, this.state.eventsJsonText);

        window.location.reload();
    }

    render() {
        let btnClass = "btn btn-default";

        return (
            <div className="container">
                <h4>
                    Overskriv lokale data
                </h4>
                <p>
                    Partidata:<br/>
                    <textarea name="partiJsonText" rows="10" cols="40" className="kritikk-textarea"
                                                         onChange={this.handleInputChange} />

                    <br/>
                    <br/>
                    Eventdata:<br/>
                    <textarea name="eventsJsonText" rows="10" cols="40" className="kritikk-textarea"

                              onChange={this.handleInputChange} /><br/>
                    <button className={btnClass} onClick={this.onSubmit} >
                      Gem
                    </button>
                </p>
            </div>
        );
    }


}
export default Insert;





// WEBPACK FOOTER //
// ./src/pages/insert/Insert.js